<script setup lang="ts">
/* Components */
import AppButton from '@/components/App/AppButton.vue'
import DeliveryInfoText from '@/components/Delivery/DeliveryInfoText.vue'

/* Stores */
import { useDeliveryStore } from '@/store/delivery/delivery'
import { useCityStore } from '@/store/city/city'

/* Types */
import { DeliveryInfoType } from '@/store/delivery/delivery.types'

const deliveryStore = useDeliveryStore()
const cityStore = useCityStore()

const sections = [
  {
    id: '1',
    title: 'Способы оплаты — онлайн, картой или наличными при получении',
    type: DeliveryInfoType.PAYMENT,
    text: 'Доступные способы оплаты и информацию об оплате вы можете узнать на странице Оплата',
  },
  {
    id: '2',
    title: 'Среднее время доставки от 60 минут',
    type: DeliveryInfoType.TIME,
    text: 'Точное время ожидания вам будет сообщено после оформления заказа. Оно может увеличиться в зависимости от загруженности нашей кухни или условий доставки.',
  },
]

const attentionFactoid = computed(() => deliveryStore.attentionFactoid)

const phone = computed(() => cityStore.cityInfo.phone)
</script>

<template>
  <div class="delivery__info">
    <div>
      <h2 class="delivery__info-headline">
        Что делать, если адрес не входит в зону доставки
      </h2>

      <p class="delivery__info-description">
        Всю информацию по условиям доставки можно уточнить у менеджера вашего
        города. Если адрес доставки не входит в зону доставки, продавец вправе
        по договорённости с клиентом осуществить доставку заказа на
        индивидуальных условиях.
      </p>

      <app-button class="delivery__info-button" :href="`tel:${phone}`">
        Связаться с нами
      </app-button>

      <delivery-info-text
        v-if="attentionFactoid"
        class="delivery__info-text"
        :title="attentionFactoid.title || ''"
        :text="attentionFactoid.text || ''"
        :type="DeliveryInfoType.ATTENTION"
      />

      <delivery-info-text
        v-for="section in sections"
        :key="section.id"
        class="delivery__info-text"
        :title="section.title"
        :text="section.text"
        :type="section.type"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep {
  .v-btn {
    min-width: 280px !important;
    height: 50px !important;
    font-weight: 800;
    color: $text-black !important;
    background-color: $button-background !important;
    border-radius: 10px;
    box-shadow: none !important;

    @include media('<tablet') {
      min-width: 100%;
    }
  }
}
.delivery__info {
  &-headline {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 800;
    line-height: 19px;
    color: $text-black;
  }

  :deep(p) {
    margin-bottom: 16px;
  }

  &-description {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    @include media('<tablet') {
      font-size: 12px;
      line-height: 17px;
    }
  }

  &-text {
    margin-bottom: 30px;
  }

  &-button {
    margin-bottom: 30px;

    @include media('<tablet') {
      width: 100%;
    }
  }
}
</style>
